import { Phone, Mail } from "lucide-react";
import { useTick } from "../hooks/useTick";

export const Footer = () => {
  const tick = useTick();
  return (
    <footer className="bg-background border-t border-border">
      <div className="max-w-[1600px] mx-auto px-5 md:px-10 py-20 md:py-28">
        <span className="text-xs font-mono uppercase tracking-[0.3em] text-muted-foreground">/ Get in touch</span>
        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-8 border-b border-border pb-16">
          <a
            data-testid="footer-phone"
            href="tel:6786938222"
            onClick={() => tick()}
            className="group block"
          >
            <div className="flex items-center gap-3 text-muted-foreground mb-3">
              <Phone size={16} /><span className="text-[10px] font-mono uppercase tracking-[0.3em]">Call Dispatch</span>
            </div>
            <span className="font-display font-black text-3xl md:text-5xl tracking-tighter group-hover:text-primary transition-colors duration-300">
              (678) 693-8222
            </span>
          </a>
          <a
            data-testid="footer-email"
            href="mailto:management@biofleetcouriers.com"
            onClick={() => tick()}
            className="group block"
          >
            <div className="flex items-center gap-3 text-muted-foreground mb-3">
              <Mail size={16} /><span className="text-[10px] font-mono uppercase tracking-[0.3em]">Email Us</span>
            </div>
            <span className="font-display font-bold text-xl md:text-3xl tracking-tight break-all group-hover:text-primary transition-colors duration-300">
              management@biofleetcouriers.com
            </span>
          </a>
        </div>

        <div className="mt-10 flex flex-col md:flex-row md:items-center justify-between gap-6">
          <div>
            <div className="font-display font-black text-sm tracking-tighter uppercase">
              BioFleet<span className="text-primary">/</span>Soulat Testing LLC
            </div>
            <p className="text-[11px] font-mono text-muted-foreground mt-2">
              Medical Courier · DNA & Drug Testing · Notary · Phlebotomy (Soon)
            </p>
          </div>
          <p className="text-[11px] font-mono text-muted-foreground">
            © {new Date().getFullYear()} BioFleet Couriers & Soulat Testing LLC. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
